import { __extends } from "tslib";
import { Event } from './Event';
var FocusEvent = /** @class */ (function (_super) {
    __extends(FocusEvent, _super);
    function FocusEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FocusEvent.prototype, "isRelatedObjectInaccessible", {
        /**
         * If true, the relatedObject property is set to null for
         * reasons related to security sandboxes.  If the nominal value of relatedObject is a reference to a
         * DisplayObject in another sandbox, relatedObject is set to
         * null unless there is permission in both directions across this sandbox boundary.  Permission is
         * established by calling Security.allowDomain() from a SWF file, or by providing
         * a policy file from the server of an image file, and setting the LoaderContext.checkPolicyFile
         * property when loading the image.
         * @langversion	3.0
         * @playerversion	Flash 10
         * @playerversion	Lite 4
         */
        get: function () {
            console.log('isRelatedObjectInaccessible not implemented yet in flash/FocusEvent');
            return false;
        },
        set: function (value) {
            console.log('isRelatedObjectInaccessible not implemented yet in flash/FocusEvent');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FocusEvent.prototype, "keyCode", {
        /**
         * The key code value of the key pressed to trigger a keyFocusChange event.
         */
        get: function () {
            console.log('keyCode not implemented yet in flash/FocusEvent');
            return 0;
        },
        set: function (value) {
            console.log('keyCode not implemented yet in flash/FocusEvent');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FocusEvent.prototype, "relatedObject", {
        /**
         * A reference to the complementary InteractiveObject instance that is affected by the
         * change in focus. For example, when a focusOut event occurs, the
         * relatedObject represents the InteractiveObject instance that has gained focus.
         * The value of this property can be null in two circumstances: if there no related object,
         * or there is a related object, but it is in a security sandbox to which you don't have access.
         * Use the isRelatedObjectInaccessible() property to determine which of these reasons applies.
         */
        get: function () {
            console.log('relatedObject not implemented yet in flash/FocusEvent');
            return null;
        },
        set: function (value) {
            console.log('relatedObject not implemented yet in flash/FocusEvent');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FocusEvent.prototype, "shiftKey", {
        /**
         * Indicates whether the Shift key modifier is activated, in which case the value is
         * true. Otherwise, the value is false. This property is
         * used only if the FocusEvent is of type keyFocusChange.
         */
        get: function () {
            console.log('shiftKey not implemented yet in flash/FocusEvent');
            return false;
        },
        set: function (value) {
            console.log('shiftKey not implemented yet in flash/FocusEvent');
        },
        enumerable: false,
        configurable: true
    });
    FocusEvent.prototype.clone = function () {
        console.log('clone not implemented yet in flash/IOErrorEvent');
        return null;
    };
    FocusEvent.prototype.toString = function () {
        console.log('toString not implemented yet in flash/FocusEvent');
        return '';
    };
    /* added to clone events from away to as3web. */
    FocusEvent.prototype.fillFromAway = function (awayEvent) {
        //console.log("cloneFromAway not implemented yet in flash/MouseEvent");
        this.adaptee = awayEvent;
        // todo: set targets correctly
        this.target = awayEvent.target;
        //this.currentTarget = awayEvent.currentTarget;
    };
    FocusEvent.FOCUS_IN = 'focusIn';
    FocusEvent.FOCUS_OUT = 'focusOut';
    FocusEvent.KEY_FOCUS_CHANGE = 'keyFocusChange';
    FocusEvent.MOUSE_FOCUS_CHANGE = 'mouseFocusChange';
    return FocusEvent;
}(Event));
export { FocusEvent };
